/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// .CD CODE.

document.addEventListener("DOMContentLoaded", function () {
  var collection_loader = document.querySelector("#js_loader");
  if (!collection_loader) return;
  collection_loader.addEventListener("click", function () {
    var button = this;
    var wrapper = button.closest(".load_more_wrap");
    if (button.classList.contains("loading")) return;
    var total_pages = parseInt(
      wrapper.getAttribute("data-total-pages")
    );
    var current_page = parseInt(
      wrapper.getAttribute("data-current-page")
    );
    var next_page = current_page + 1;
    var url = window.location.pathname + "?page=" + next_page;
    button.classList.add("loading");
    fetch(url)
      .then(function(response){
        return response.text();
      })
      .then(function(data){
        var html = new DOMParser()
          .parseFromString(data,"text/html");
        var current_grid = document.querySelector(".ProductList");
        if(!current_grid) return;
        var products = html.querySelectorAll(
          ".ProductList .Grid__Cell"
        );
        products.forEach(function(product){
          // remove animation only
          product.classList.remove(
            "Appear",
            "is-visible",
            "fadeIn"
          );
          var item = product.querySelector(
            ".ProductItem"
          );
          if(item){

            item.classList.remove(
              "Appear",
              "is-visible"
            );


            item.style.opacity = "1";
            item.style.visibility = "visible";
            item.style.transform = "none";

          }
          current_grid.appendChild(product);
        });
        // update page
        wrapper.setAttribute(
          "data-current-page",
          next_page
        );
        // hide load more after last page
        if(next_page >= total_pages){

          wrapper.remove();

        }
        document.querySelectorAll(
          ".ProductItem img[data-src]"
        ).forEach(function(img){
          var src = img.getAttribute(
            "data-src"
          );
          if(src){

            img.setAttribute(
              "src",
              src.replace(
                "{width}",
                "800"
              )
            );
            img.removeAttribute(
              "data-src"
            );

          }
        });
        button.classList.remove(
          "loading"
        );
      })
      .catch(function(error){
        console.log(
          "Load More Error",
          error
        );
        button.classList.remove(
          "loading"
        );
      });
  });
});

window.onscroll = function() {
  let scrollButton = document.getElementById("scrollButton");

  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    scrollButton.style.display = "block";
  } else {
    scrollButton.style.display = "none";
  }
};

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

document.addEventListener("DOMContentLoaded", function () {
   const desc = document.querySelector(".template-collection .SectionHeader__Description");
  const btn = document.querySelector(".template-collection .read-more-btn-col");

  if(btn){

    btn.addEventListener("click", function () {
      if (desc.style.webkitLineClamp === "unset") {
        desc.style.webkitLineClamp = "3";
        btn.innerText = "Read more";
      } else {
        desc.style.webkitLineClamp = "unset";
        btn.innerText = "Read less";
      }
    });
  }
});